<template>
  <div class="contentBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button
        v-if="keyJumpt != 7"
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="submit('SAVE')"
        >保存</el-button
      >
      <el-button
        v-if="keyJumpt == 7 && otherId"
        style="margin-top: 10px"
        class="glo_bg"
        @click="onClick(1)"
        >一级审核通过</el-button
      >
      <el-button
        v-if="keyJumpt == 7 && otherId"
        style="margin-top: 10px"
        class="glo_bg"
        @click="onClick(2)"
        >二级审核通过</el-button
      >
      <el-button
        v-if="keyJumpt != 7"
        style="margin-top: 10px"
        class="glo_bg"
        @click="submit('POSTING')"
        >保存并过账</el-button
      >
      <el-button
        v-if="keyJumpt == 7 && otherId"
        style="margin-top: 10px"
        class="glo_bg"
        @click="submit('GZBHX')"
        >过账并核销</el-button
      >
    </div>

    <div class="infoDiv">
      <div class="h3title">基本信息</div>
      <div class="formbox">
        <el-form class="glo_formBox" label-width="120px">
          <el-form-item label="报销部门:" required>
            <el-select
              :disabled="keyJumpt == 7"
              filterable
              clearable
              v-model="dialogFormDispatch.businessDeptId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in depList"
                :key="item.deptId"
                :label="item.departmentName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            style="width: 500px"
            class="dialogFormItems"
            required
            label="垫付人:"
          >
            <div class="multipleSelect">
              <el-select
                :disabled="keyJumpt == 7"
                filterable
                clearable
                v-model="objectStatusType"
                placeholder="请选择"
                @change="changeObjestStatus"
              >
                <el-option
                  v-for="(item, index) in objectStatusList"
                  :key="index"
                  :label="item.val"
                  :value="item.key"
                ></el-option>
              </el-select>
              <el-select
                :disabled="keyJumpt == 7"
                filterable
                clearable
                v-model="dialogFormDispatch.objectName"
                placeholder="请选择"
                :allow-create="objectStatusType == 'other'"
                remote
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            style="width: 500px"
            required
            class="dialogFormItems"
            label="费项:"
          >
            <div class="multipleSelect">
              <el-select
                :disabled="keyJumpt == 7"
                filterable
                clearable
                v-model="dialogFormDispatch.itemCategoryId"
                placeholder="请选择"
                @change="changeItemCategoryId"
              >
                <el-option
                  v-for="item in categoryNameList"
                  :key="item.categoryId"
                  :label="item.categoryName"
                  :value="item.categoryId"
                ></el-option>
              </el-select>
              <el-select
                :disabled="keyJumpt == 7"
                filterable
                clearable
                v-model="dialogFormDispatch.itemServiceId"
                placeholder="请选择"
                @change="changeItemServiceId"
              >
                <el-option
                  v-for="item in CategoryServiceList"
                  :key="item.itemServiceId"
                  :label="item.title"
                  :value="item.itemServiceId + ''"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item required label="发生金额:">
            <div class="disFlexs jsInput">
              <el-input
                @input="amountInput"
                :disabled="keyJumpt == 7"
                v-model="dialogFormDispatch.amount"
                placeholder="请输入"
              ></el-input>
              <el-button
                v-if="
                  dialogFormDispatch.reimbursementDirection ==
                    'bill_tms_waybill_outgoing_v3:reimbursement_direction' ||
                  dialogFormDispatch.reimbursementDirection ==
                    'bill_tms_waybill_v3_finance_out_service:reimbursement_direction' ||
                  dialogFormDispatch.reimbursementDirection ==
                    'bill_tms_dispatch_v3:reimbursement_direction'
                "
                class="jsBtns glo_bgcMainColor"
                @click="countBaseFee()"
                >计算</el-button
              >
            </div>
          </el-form-item>
          <el-form-item class="dialogFormItems" required label="付款方式:">
            <el-select
              :disabled="keyJumpt == 7"
              filterable
              clearable
              v-model="dialogFormDispatch.settlementMethodConfDictId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in settlementMethodList"
                :key="item.confDictId"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请日期:" required>
            <el-date-picker
              :disabled="keyJumpt == 7"
              v-model="dialogFormDispatch.occurrenceTime"
              class="input"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="核销方式:" required>
            <el-select
              :disabled="keyJumpt == 7"
              @change="changeWriteoffMethod"
              clearable
              v-model="dialogFormDispatch.writeoffMethod"
              placeholder="请选择"
            >
              <el-option
                v-for="item in writeoff_methodList"
                :key="item.statusVal"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="借支账号:">
            <el-select
              :disabled="
                keyJumpt == 7 ||
                dialogFormDispatch.writeoffMethod == 'cai_wu:writeoff_method'
              "
              filterable
              clearable
              v-model="dialogFormDispatch.zjAccount"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in fundAccountList"
                :key="index"
                :label="item.account"
                :value="item.account"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="借支核销金额:" required>
            <el-input
              :disabled="
                keyJumpt == 7 ||
                dialogFormDispatch.writeoffMethod == 'cai_wu:writeoff_method'
              "
              v-model="dialogFormDispatch.settlementAmount"
              placeholder="请输入"
              clearable
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item class="textArea" style="width: 100%" label="备注:">
            <el-input
              :disabled="keyJumpt == 7"
              type="textarea"
              v-model="dialogFormDispatch.remark"
            ></el-input>
          </el-form-item>
          <div class="uploadBox">
            <div class="uploadLaber">图片:</div>
            <div class="uploadItem">
              <uploadimgs
                :disabled="keyJumpt == 7"
                @input="changeFileList_zh"
                :fileNameLists="fileNameLists1"
                :limit="9"
              ></uploadimgs>
            </div>
          </div>
        </el-form>
      </div>
      <div
        v-if="
          dialogFormDispatch.reimbursementDirection ==
            'bill_tms_waybill_split_v3:reimbursement_direction' ||
          dialogFormDispatch.reimbursementDirection ==
            'car_v3:reimbursement_direction' ||
          dialogFormDispatch.reimbursementDirection ==
            'bill_tms_waybill_outgoing_v3:reimbursement_direction' ||
          dialogFormDispatch.reimbursementDirection ==
            'bill_tms_dispatch_v3:reimbursement_direction' ||
          dialogFormDispatch.reimbursementDirection ==
            'bill_tms_waybill_v3_finance_out_service:reimbursement_direction'
        "
      >
        <div
          class="h3title"
          v-if="
            dialogFormDispatch.reimbursementDirection ==
            'bill_tms_waybill_split_v3:reimbursement_direction'
          "
        >
          运单明细
        </div>
        <div
          class="h3title"
          v-if="
            dialogFormDispatch.reimbursementDirection ==
            'car_v3:reimbursement_direction'
          "
        >
          车辆明细
        </div>
        <div
          class="h3title"
          v-if="
            dialogFormDispatch.reimbursementDirection ==
            'bill_tms_waybill_outgoing_v3:reimbursement_direction'
          "
        >
          外发明细
        </div>
        <div
          class="h3title"
          v-if="
            dialogFormDispatch.reimbursementDirection ==
            'bill_tms_dispatch_v3:reimbursement_direction'
          "
        >
          发车明细
        </div>
        <div
          class="h3title"
          v-if="
            dialogFormDispatch.reimbursementDirection ==
            'bill_tms_waybill_v3_finance_out_service:reimbursement_direction'
          "
        >
          运单应付明细
        </div>
        <div class="glo_btnList" ref="btnList" v-if="keyJumpt != 7">
          <div class="glo_btnList_left">
            <el-button
              class="glo_btnItems"
              @click="clickAdd"
              v-if="
                dialogFormDispatch.reimbursementDirection !=
                  'bill_tms_waybill_outgoing_v3:reimbursement_direction' &&
                dialogFormDispatch.reimbursementDirection !=
                  'bill_tms_dispatch_v3:reimbursement_direction' &&
                dialogFormDispatch.reimbursementDirection !=
                  'bill_tms_waybill_v3_finance_out_service:reimbursement_direction'
              "
              >单票添加</el-button
            >
            <el-button class="glo_btnItems" @click="clickRetrieve"
              >取出明细</el-button
            >
            <el-button class="glo_btnItems" @click="clickDel">移除</el-button>
            <el-button
              class="glo_btnItems"
              @click="clickCostSharing"
              v-if="
                dialogFormDispatch.reimbursementDirection ==
                  'bill_tms_waybill_split_v3:reimbursement_direction' ||
                dialogFormDispatch.reimbursementDirection ==
                  'car_v3:reimbursement_direction'
              "
              >费用均摊</el-button
            >
          </div>
        </div>
        <!-- 表格 -->
        <div class="glo_Table">
          <el-table
            header-align="center"
            ref="mytable"
            :data="tableData1"
            @selection-change="handleSelectionChange1"
            show-summary
            :summary-method="getSummaries"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column
              v-if="keyJumpt != 7"
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <el-table-column
              label="摊分金额"
              width="200"
              prop="amount"
              v-if="
                dialogFormDispatch.reimbursementDirection !=
                  'bill_tms_waybill_outgoing_v3:reimbursement_direction' &&
                dialogFormDispatch.reimbursementDirection !=
                  'bill_tms_waybill_v3_finance_out_service:reimbursement_direction' &&
                dialogFormDispatch.reimbursementDirection !=
                  'bill_tms_dispatch_v3:reimbursement_direction'
              "
            >
              <template slot-scope="scope">
                <el-input
                  :disabled="keyJumpt == 7"
                  @input="onInputHW($event, scope.$index)"
                  v-model="tableData1[scope.$index].amount"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </template>
            </el-table-column>
            <template v-for="(item, index) in myTableHeard1">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </div>
      <!-- 单票添加 -->
      <myDialog
        :diaWidth="diaWidth2"
        :dialogTitle="dialogTitle2"
        :isShowDialog="isShowDialog2"
        @handleCloseDia="handleCloseDia2"
        @diaCancelBtn="handleCloseDia2"
        @diaConfirmBtn="diaConfirmBtn2"
      >
        <div class="formbox" v-if="isShowDialog2">
          <el-form class="glo_formBox" label-width="110px">
            <el-form-item
              label="运单号:"
              style="width: 100%"
              v-if="
                dialogFormDispatch.reimbursementDirection ==
                'bill_tms_waybill_split_v3:reimbursement_direction'
              "
            >
              <!-- <el-input v-model.trim="queryData3.waybillNumber" placeholder="请输入"></el-input> -->
              <el-select
                v-model="queryData3.waybillNumber"
                placeholder="请选择"
                clearable
                remote
                filterable
                :remote-method="
                  (e) => {
                    remoteMethod_waybillNumber(e);
                  }
                "
                @focus="focusMetho_waybillNumber()"
                @clear="remoteMethod_waybillNumber('')"
              >
                <el-option
                  v-for="(item, index) in waybillNumberList"
                  :key="index"
                  :label="item.waybillNumber"
                  :value="item.waybillNumber"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="车牌号:"
              style="width: 100%"
              v-if="
                dialogFormDispatch.reimbursementDirection ==
                'car_v3:reimbursement_direction'
              "
            >
              <!-- <el-input v-model="queryData6.carNumber" placeholder="请输入"></el-input> -->
              <el-select
                v-model="queryData6.carNumber"
                placeholder="请选择"
                clearable
                remote
                filterable
                :remote-method="
                  (e) => {
                    remoteMethod_carNumber(e);
                  }
                "
                @focus="focusMetho_carNumber()"
                @clear="remoteMethod_carNumber('')"
              >
                <el-option
                  v-for="(item, index) in carNumberList"
                  :key="index"
                  :label="item.carNumber"
                  :value="item.carNumber"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="外发编号:"
              style="width: 100%"
              v-if="
                dialogFormDispatch.reimbursementDirection ==
                'bill_tms_waybill_outgoing_v3:reimbursement_direction'
              "
            >
              <!-- <el-input v-model="queryData4.number" placeholder="请输入"></el-input> -->
              <el-select
                v-model="queryData4.number"
                placeholder="请选择"
                clearable
                remote
                filterable
                :remote-method="
                  (e) => {
                    remoteMethod_outgoingNumber(e);
                  }
                "
                @focus="focusMetho_outgoingNumber()"
                @clear="remoteMethod_outgoingNumber('')"
              >
                <el-option
                  v-for="(item, index) in outgoingNumberList"
                  :key="index"
                  :label="item.number"
                  :value="item.number"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="发车批次号:"
              style="width: 100%"
              v-if="
                dialogFormDispatch.reimbursementDirection ==
                'bill_tms_dispatch_v3:reimbursement_direction'
              "
            >
              <!-- <el-input v-model="queryData5.number" placeholder="请输入"></el-input> -->
              <el-select
                v-model="queryData5.number"
                placeholder="请选择"
                clearable
                remote
                filterable
                :remote-method="
                  (e) => {
                    remoteMethod_fcnumber(e);
                  }
                "
                @focus="focusMetho_fcnumber()"
                @clear="remoteMethod_fcnumber('')"
              >
                <el-option
                  v-for="(item, index) in fcnumberList"
                  :key="index"
                  :label="item.number"
                  :value="item.number"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </myDialog>
      <!-- 费用均摊 -->
      <myDialog
        :diaWidth="diaWidth1"
        :dialogTitle="dialogTitle1"
        :isShowDialog="isShowDialog1"
        @handleCloseDia="handleCloseDia1"
        @diaCancelBtn="handleCloseDia1"
        @diaConfirmBtn="diaConfirmBtn1"
      >
        <div class="formbox" v-if="isShowDialog1">
          <el-form class="glo_formBox" label-width="110px">
            <el-form-item label="计费方式:" style="width: 100%">
              <el-select
                v-model="dialogForm1.formulaBillingWeightId"
                placeholder="请输入"
                clearable
              >
                <el-option
                  v-for="item in out_going_billing_method_list"
                  :key="item.formulaBillingWeightId + ''"
                  :label="item.formulaBillingWeightName"
                  :value="item.formulaBillingWeightId + ''"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </myDialog>
      <!-- 运单取出明细 -->
      <myDialog
        :diaWidth="diaWidth3"
        :dialogTitle="dialogTitle3"
        :isShowDialog="isShowDialog3"
        @handleCloseDia="handleCloseDia3"
        @diaCancelBtn="handleCloseDia3"
        @diaConfirmBtn="diaConfirmBtn3"
      >
        <div class="glo_dialogForm" v-if="isShowDialog3">
          <!-- 查询条件 -->
          <div ref="queryForm">
            <el-form class="glo_form hasMoreParam" label-position="left">
              <el-form-item class="queryItemsTimes">
                <multitime
                  :timeType="timeType3"
                  :timeTypes="timeTypes3"
                  :startTime="startTime_a3"
                  :endTime="endTime_a3"
                  @timestatus="timestatus3"
                  @queryBtn_ok="queryBtn_time3"
                ></multitime>
              </el-form-item>
              <el-form-item class="queryItems" label="运单号:">
                <el-input
                  clearable
                  v-model="queryData3.waybillNumber"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="客户名称:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData3.customerNumber"
                  placeholder="请输入客户编号"
                  remote
                  :remote-method="getCustomerList"
                  @change="changeCustomerNumber"
                  @focus="getCustomerList()"
                >
                  <el-option
                    v-for="(item, index) in CustomerLists"
                    :key="index"
                    :label="item.name"
                    :value="item.number"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-button
                class="glo_btnItems glo_bgcMainColor"
                @click="clickQuery3(1)"
                >查询</el-button
              >
            </el-form>
          </div>
          <div class="glo_Table">
            <el-table
              header-align="center"
              height="450"
              ref="mytable3"
              @row-click="rowclick3"
              :data="tableData3"
              border
              stripe
              @selection-change="handleSelectionChange3"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column
                fixed="left"
                align="center"
                type="selection"
                width="60"
              ></el-table-column>
              <template v-for="(item, index) in myTableHeard3">
                <el-table-column
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="center"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
                  v-if="item && item.isShow"
                ></el-table-column>
              </template>
            </el-table>
          </div>
          <!-- 分页 -->
          <paging
            ref="pags"
            :pageNum="pageStart3"
            :total="pageCount3"
            :size="pageTotal3"
            @handleSizeChange="handleSizeChange3"
            @handleCurrentChange="handleCurrentChange3"
          ></paging>
        </div>
      </myDialog>
      <!-- 外发取出明细 -->
      <myDialog
        :diaWidth="diaWidth4"
        :dialogTitle="dialogTitle4"
        :isShowDialog="isShowDialog4"
        @handleCloseDia="handleCloseDia4"
        @diaCancelBtn="handleCloseDia4"
        @diaConfirmBtn="diaConfirmBtn4"
      >
        <div class="glo_dialogForm" v-if="isShowDialog4">
          <!-- 查询条件 -->
          <div ref="queryForm">
            <el-form class="glo_form hasMoreParam" label-position="left">
              <el-form-item class="queryItemsTimes">
                <multitime
                  :timeType="timeType4"
                  :timeTypes="timeTypes4"
                  :startTime="startTime_a4"
                  :endTime="endTime_a4"
                  @timestatus="timestatus4"
                  @queryBtn_ok="queryBtn_time4"
                ></multitime>
              </el-form-item>
              <el-form-item class="queryItems" label="外发单号:">
                <el-input
                  clearable
                  placeholder="请输入"
                  v-model="queryData4.number"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="结算方式:">
                <el-select
                  v-model="queryData4.settlementMethodConfDictId"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="item in out_going_settlement_method_list"
                    :key="item.confDictId"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="运单号:">
                <el-input
                  clearable
                  placeholder="请输入"
                  v-model="queryData4.waybillNumber"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="客户名称:">
                <el-input
                  clearable
                  placeholder="请输入"
                  v-model="queryData4.customerName"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="承运商名称:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData4.carrierName"
                  placeholder="请输入"
                  remote
                  :remote-method="getCarrierList"
                  @focus="getCarrierList()"
                >
                  <el-option
                    v-for="(item, index) in CarrierLists"
                    :key="index"
                    :label="item.carrierName"
                    :value="item.carrierName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="业务网点:">
                <el-select
                  v-model="queryData4.businessDeptId"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in depList"
                    :key="index"
                    :label="item.departmentName"
                    :value="item.deptId"
                  />
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="发货人:">
                <el-select
                  v-model="queryData4.sendEmployeeId"
                  placeholder="请选择"
                  clearable
                  remote
                  filterable
                  :remote-method="
                    (e) => {
                      remoteMethod(e, 'employee', 'employeeList');
                    }
                  "
                  @focus="
                    (e) => {
                      focusMethod('employee', 'employeeList');
                    }
                  "
                  @clear="remoteMethod('', 'employee', 'employeeList')"
                >
                  <el-option
                    v-for="(item, index) in employeeList"
                    :key="index"
                    :label="item.name"
                    :value="Number(item.documentId)"
                  />
                </el-select>
              </el-form-item>
              <el-button
                class="glo_btnItems glo_bgcMainColor"
                @click="clickQuery4(1)"
                >查询</el-button
              >
            </el-form>
          </div>
          <div class="glo_Table">
            <el-table
              header-align="center"
              height="450"
              ref="mytable4"
              @row-click="rowclick4"
              :data="tableData4"
              border
              stripe
              @selection-change="handleSelectionChange4"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column
                fixed="left"
                align="center"
                type="selection"
                width="60"
              ></el-table-column>
              <template v-for="(item, index) in myTableHeard4">
                <el-table-column
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="center"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
                  v-if="item && item.isShow"
                ></el-table-column>
              </template>
            </el-table>
          </div>
          <!-- 分页 -->
          <paging
            ref="pags"
            :pageNum="pageStart4"
            :total="pageCount4"
            :size="pageTotal4"
            @handleSizeChange="handleSizeChange4"
            @handleCurrentChange="handleCurrentChange4"
          ></paging>
        </div>
      </myDialog>

      <!-- 发车取出明细 配载-->
      <myDialog
        :diaWidth="diaWidth5"
        :dialogTitle="dialogTitle5"
        :isShowDialog="isShowDialog5"
        @handleCloseDia="handleCloseDia5"
        @diaCancelBtn="handleCloseDia5"
        @diaConfirmBtn="diaConfirmBtn5"
      >
        <div class="glo_dialogForm" v-if="isShowDialog5">
          <!-- 查询条件 -->
          <div ref="queryForm">
            <el-form class="glo_form hasMoreParam" label-position="left">
              <el-form-item class="queryItemsTimes">
                <multitime
                  :timeType="timeType5"
                  :timeTypes="timeTypes5"
                  :startTime="startTime_a5"
                  :endTime="endTime_a5"
                  @timestatus="timestatus5"
                  @queryBtn_ok="queryBtn_time5"
                ></multitime>
              </el-form-item>
              <el-form-item class="queryItems" label="发车批次号:">
                <el-input
                  placeholder="请输入"
                  clearable
                  v-model="queryData5.number"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="运单号:">
                <el-input
                  clearable
                  placeholder="请输入"
                  v-model="queryData5.waybillNumber"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="垫付人:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData5.preparerEmployeeId"
                  placeholder="请选择"
                  remote
                  :remote-method="
                    (val) => {
                      getemployee(val);
                    }
                  "
                  @focus="getemployee()"
                >
                  <el-option
                    v-for="(item, index) in employeeList55"
                    :key="index"
                    :label="item.name"
                    :value="Number(item.documentId)"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="收款对象:"
                style="width: 470px"
                class="queryItems"
              >
                <div class="twoInput">
                  <el-select
                    style="width: 185px"
                    v-model="queryData5.objectStatusConfDictId"
                    placeholder="请选择"
                    @change="changeObjestStatusYS"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in objectStatusList"
                      :key="index"
                      :label="item.val"
                      :value="item.confDictId"
                    ></el-option>
                  </el-select>
                  <el-select
                    style="width: 185px"
                    v-model="queryData5.objectName"
                    clearable
                    remote
                    filterable
                    :allow-create="queryData5.objectStatusConfDictId == 'other'"
                    :remote-method="getObjectUserDownListYf1"
                    @change="changeobjectName1"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in CustomerListsYF1"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-button
                class="glo_btnItems glo_bgcMainColor"
                @click="clickQuery5(1)"
                >查询</el-button
              >
            </el-form>
          </div>
          <div class="glo_Table">
            <el-table
              header-align="center"
              height="450"
              ref="mytable5"
              @row-click="rowclick5"
              :data="tableData5"
              border
              stripe
              @selection-change="handleSelectionChange5"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column
                fixed="left"
                align="center"
                type="selection"
                width="60"
              ></el-table-column>
              <template v-for="(item, index) in myTableHeard5">
                <el-table-column
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="center"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
                  v-if="item && item.isShow"
                ></el-table-column>
              </template>
            </el-table>
          </div>
          <!-- 分页 -->
          <paging
            ref="pags"
            :pageNum="pageStart5"
            :total="pageCount5"
            :size="pageTotal5"
            @handleSizeChange="handleSizeChange5"
            @handleCurrentChange="handleCurrentChange5"
          ></paging>
        </div>
      </myDialog>

      <!-- 车辆取出明细-->
      <myDialog
        :diaWidth="diaWidth6"
        :dialogTitle="dialogTitle6"
        :isShowDialog="isShowDialog6"
        @handleCloseDia="handleCloseDia6"
        @diaCancelBtn="handleCloseDia6"
        @diaConfirmBtn="diaConfirmBtn6"
      >
        <div class="glo_dialogForm" v-if="isShowDialog6">
          <!-- 查询条件 -->
          <div ref="queryForm">
            <el-form class="glo_form hasMoreParam" label-position="left">
              <el-form-item class="queryItems" label="车牌号:">
                <el-input
                  placeholder="请输入"
                  clearable
                  v-model="queryData6.carNumber"
                ></el-input>
              </el-form-item>
              <el-button
                class="glo_btnItems glo_bgcMainColor"
                @click="clickQuery6"
                >查询</el-button
              >
            </el-form>
          </div>
          <div class="glo_Table">
            <el-table
              header-align="center"
              height="450"
              ref="mytable6"
              @row-click="rowclick6"
              :data="tableData6"
              border
              stripe
              @selection-change="handleSelectionChange6"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column
                fixed="left"
                align="center"
                type="selection"
                width="60"
              ></el-table-column>
              <template v-for="(item, index) in myTableHeard6">
                <el-table-column
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="center"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
                  v-if="item && item.isShow"
                ></el-table-column>
              </template>
            </el-table>
          </div>
          <!-- 分页 -->
          <paging
            ref="pags"
            :pageNum="pageStart6"
            :total="pageCount6"
            :size="pageTotal6"
            @handleSizeChange="handleSizeChange6"
            @handleCurrentChange="handleCurrentChange6"
          ></paging>
        </div>
      </myDialog>

      <!-- 运单应付费用报销-->
      <myDialog
        :diaWidth="diaWidth7"
        :dialogTitle="dialogTitle7"
        :isShowDialog="isShowDialog7"
        @handleCloseDia="handleCloseDia7"
        @diaCancelBtn="handleCloseDia7"
        @diaConfirmBtn="diaConfirmBtn7"
      >
        <div class="glo_dialogForm" v-if="isShowDialog7">
          <!-- 查询条件 -->
          <!-- :formData="queryData" -->
          <div style="display: flex; align-items: center">
            <queryCondition
              ref="queryForm"
              :More="true"
              :formConfig="queryCondditionDatas"
            ></queryCondition>
            <el-button
              class="glo_btnItems glo_bgcMainColor"
              @click="clickQuery7"
              >查询</el-button
            >
          </div>
          <!-- 表格 -->
          <div class="glo_Table">
            <el-table
              height="450"
              header-align="center"
              ref="mytable7"
              @row-click="rowclick"
              :data="tableData"
              show-summary
              :summary-method="getSummaries"
              border
              stripe
              :highlight-current-row="true"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column
                fixed="left"
                align="center"
                type="selection"
                width="60"
              ></el-table-column>
              <template v-for="(item, index) in myTableHeard">
                <el-table-column
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="center"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
                  v-if="item && item.isShow"
                ></el-table-column>
              </template>
            </el-table>
          </div>

          <!-- 分页 -->
          <paging
            ref="pags"
            :pageNum="pageStart"
            :total="pageCount"
            :size="pageTotal"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </myDialog>
    </div>

    <!-- 核销 -->
    <myDialog
      :diaWidth="diaWidth8"
      :dialogTitle="dialogTitle8"
      :isShowDialog="isShowDialog8"
      @handleCloseDia="handleCloseDia8"
      @diaCancelBtn="handleCloseDia8"
      @diaConfirmBtn="diaConfirmBtn8"
    >
      <div class="glo_dialogForm" v-if="isShowDialog8">
        <div class="formbox">
          <el-form class="glo_formBox" label-width="120px">
            <el-form-item required label="财务编号:">
              <div class="disFlexs jsInput">
                <el-input
                  v-model="queryData8.financeNumber"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item required label="核销金额:">
              <div class="disFlexs jsInput">
                <el-input
                  v-model="queryData8.settlementAmount"
                  placeholder="请输入"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item
              class="dialogFormItems"
              required
              label="核销资金账号:"
            >
              <el-select
                filterable
                clearable
                v-model="queryData8.accountId"
                placeholder="请选择"
                @visible-change="getfundAccountListHx"
                remote
                :remote-method="(res) => getfundAccountListHxName(res)"
              >
                <el-option
                  v-for="(item, index) in fundAccountListHx"
                  :key="index"
                  :label="item.account"
                  :value="item.assetaccountId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="核销时间:" required>
              <el-date-picker
                v-model="queryData8.writeOffTime"
                class="input"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>

            <el-form-item class="textArea" style="width: 100%" label="备注:">
              <el-input
                type="textarea"
                v-model="queryData8.writeoffComment"
              ></el-input>
            </el-form-item>
            <div class="uploadBox">
              <div class="uploadLaber">核销图片:</div>
              <div class="uploadItem">
                <uploadimgs
                  @input="changeFileList8"
                  :fileNameLists="fileNameLists8"
                  :limit="9"
                ></uploadimgs>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </myDialog>
  </div>
</template>
<script>
import tableList from "@/pages/tableList.js";
import myDialog from "@/components/Dialog.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import _ from "lodash";
import queryCondition from "@/components/queryCondition.vue";
export default {
  inject: ["reload"],
  mixins: [tableList],
  components: {
    myDialog,
    uploadimgs,
    multitime,
    paging,
    queryCondition,
  },
  data() {
    return {
      businessDeptIdArr: [],
      out_going_settlement_method_list: [],
      employeeList55: [],
      fcnumberList: [],
      outgoingNumberList: [],
      carNumberList: [],
      waybillNumberList: [],
      tableData1: [],
      DELArrys: [], //移除的数组
      myTableHeard1: [],
      //运单明细 运单取出明细
      myTableHeard1yd: [
        {
          name: "预计提货费",
          field: "planTakeFee",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "预计送货费",
          field: "planSendFee",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单客户",
          field: "customerName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "到达区域",
          field: "arrivalArea",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货电话",
          field: "receivePhone",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货公司名称",
          field: "receiveCompany",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货省份",
          field: "receiveProvinceName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货城市",
          field: "receiveCityName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货区县",
          field: "receiveAreaName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货地址",
          field: "receiveAddress",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "totalCount",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "totalNetWeight",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "totalGrossWeight",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/方",
          field: "totalVolume",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "送货费",
          field: "sendFee",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单总费用",
          field: "billingAmount",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单备注",
          field: "remarks",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单网点",
          field: "currentDeptName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单时间",
          field: "businessDate",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      //车辆明细
      myTableHeard1cl: [
        {
          name: "车牌号",
          field: "carNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车辆分类",
          field: "carCategoryName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车型",
          field: "carTypeName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车辆使用部门",
          field: "useDeptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "活动区域",
          field: "actionZone",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      //外发明细 外发取出明细
      myTableHeard1wf: [
        {
          name: "提货日期",
          field: "takeTime",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "承运商",
          field: "carrierName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "承运商单号",
          field: "outgoingNumber",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "到货区域",
          field: "arrivalArea",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货品名称",
          field: "goodsName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "送货方式",
          field: "sendMethod",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "totalCount",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重/kg",
          field: "totalNetWeight",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重/kg",
          field: "totalGrossWeight",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/方",
          field: "totalVolume",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费方式",
          field: "formulaBillingWeight",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "承运商单价",
          field: "unitPrice",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运费",
          field: "basicFreight",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "送货费",
          field: "sendFee",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "其他费用",
          field: "allOtherFee",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "合计费用",
          field: "totalFreight",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装卸费",
          field: "unLoadFee",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "提货费",
          field: "takeFee",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货人",
          field: "sendEmployeeName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },



        {
          name: "是否过账",
          field: "isPostingShow",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户单号",
          field: "customerOrderNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发网点",
          field: "startDeptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发日期",
          field: "outgoingTime",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发结算方式",
          field: "settlementMethod",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "预计计费方式",
          field: "planFormulaBillingWeight",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "预计送货费",
          field: "planSendFee",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "预计运费",
          field: "planFreight",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "预计其他费用",
          field: "planOtherFee",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "预计费用合计",
          field: "planTotalAmount",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "编号",
          field: "number",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      //发车明细 发车取出明细
      myTableHeard1fc: [
        {
          name: "发车批次号",
          field: "number",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发车时间",
          field: "departureTime",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "垫付人",
          field: "preparerEmployeeName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "费用合计",
          field: "financeOutAmount",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车牌号码",
          field: "carNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车型",
          field: "carType",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "任务票数",
          field: "taksCount",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "包含运单号",
          field: "waybillNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货城市",
          field: "receiveCityName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "总件数",
          field: "totalCount",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "总毛重kg",
          field: "totalGrossWeight",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "总净重kg",
          field: "totalNetWeight",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "总体积m³",
          field: "totalVolume",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "结算对象类型",
          field: "objectStatus",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "结算对象",
          field: "objectName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "付款方式",
          field: "paymentMethod",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机",
          field: "driverName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机电话",
          field: "driverPhone",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },


        {
          name: "类型",
          field: "departureTypeShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "挂车号码",
          field: "trailerNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "调度状态",
          field: "dispatchStatusShow",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "申请报销状态",
          field: "applyReimburseStatus",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机身份证",
          field: "driverIdcard",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货员",
          field: "sendNotifierName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "随车人员",
          field: "carFollowPersonnelName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运单重量kg",
          field: "totalWeight",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车辆类型",
          field: "carCategory",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机属性",
          field: "driverAttribute",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "行驶里程数",
          field: "mileage",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开始里程数",
          field: "startMileage",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "结束里程数",
          field: "endMileage",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "完成时间",
          field: "completeTime",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      selectTableData1: [],
      pageStart: 1,
      pageTotal: 100,

      objectStatusType: "",
      objectStatusType1: "",
      dialogFormDispatch: {
        amount: "",
        businessDeptId: "",
        fileIds: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        occurrenceTime: this.$TOOLS.getCurrentTime(),
        operationType: "SAVE",
        reimbursementDirection: "",
        remark: "",
        settlementAmount: "",
        settlementMethodConfDictId: "",
        writeoffMethod: "",
        zjAccount: "",
        waybills: [],
      },

      isShowDialog1: false,
      dialogTitle1: "费用均摊",
      diaWidth1: "520px",
      dialogForm1: {
        formulaBillingWeightId: "",
      },
      out_going_billing_method_list: [],

      isShowDialog2: false,
      dialogTitle2: "单票添加",
      diaWidth2: "520px",
      dialogForm2: {
        remarks: "",
      },

      isShowDialog3: false,
      dialogTitle3: "运单取出明细",
      diaWidth3: "90%",
      tableData3: [],
      myTableHeard3: [
        {
          name: "运单号",
          field: "waybillNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "到达区域",
          field: "arrivalArea",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "totalGrossWeight	",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "totalNetWeight",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/方",
          field: "totalVolume",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "规格",
          field: "itemSpecs",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输方式",
          field: "transportMethod",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货地址",
          field: "takeAddress",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货地址",
          field: "receiveAddress",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      selectTableData3: [], //收发地址 表格选择
      //  -----  查询  ------
      queryData3: {
        waybillNumber: "",
        startBusinessTime: "",
        startCreateTime: "",
        endBusinessTime: "",
        endCreateTime: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes3: [
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "1",
          label: "业务日期",
        },
      ],
      timeType3: "0", //  时间类型
      startTime_a3: "",
      endTime_a3: "",
      CustomerLists: [],
      pageStart3: 1, //  页码
      pageCount3: 0, //  总条数
      pageTotal3: this.$COMMON.pageTotals, //  一页几条
      pageStart4: 1, //  页码
      pageCount4: 0, //  总条数
      pageTotal4: this.$COMMON.pageTotals, //  一页几条
      pageStart5: 1, //  页码
      pageCount5: 0, //  总条数
      pageTotal5: this.$COMMON.pageTotals, //  一页几条
      pageStart6: 1, //  页码
      pageCount6: 0, //  总条数
      pageTotal6: this.$COMMON.pageTotals, //  一页几条

      isShowDialog4: false,
      dialogTitle4: "外发取出明细",
      diaWidth4: "90%",
      tableData4: [],
      myTableHeard4: [
        {
          name: "提货日期",
          field: "takeTime",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "承运商",
          field: "carrierName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "承运商单号",
          field: "outgoingNumber",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "到货区域",
          field: "arrivalArea",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货品名称",
          field: "goodsName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "送货方式",
          field: "sendMethod",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "totalCount",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重/kg",
          field: "totalNetWeight",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重/kg",
          field: "totalGrossWeight",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/方",
          field: "totalVolume",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费方式",
          field: "formulaBillingWeight",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "承运商单价",
          field: "unitPrice",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运费",
          field: "basicFreight",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "送货费",
          field: "sendFee",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "其他费用",
          field: "allOtherFee",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "合计费用",
          field: "totalFreight",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装卸费",
          field: "unLoadFee",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "提货费",
          field: "takeFee",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货人",
          field: "takeContacts",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },


        {
          name: "是否过账",
          field: "isPostingShow",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发结算方式",
          field: "settlementMethod",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户单号",
          field: "customerOrderNumber",
          width: "150",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发网点",
          field: "startDeptName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发日期",
          field: "outgoingTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "预计计费方式",
          field: "planFormulaBillingWeight",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "预计送货费",
          field: "planSendFee",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "预计运费",
          field: "planFreight",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "预计其他费用",
          field: "planOtherFee",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "预计费用合计",
          field: "planTotalAmount",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建人",
          field: "outgoingCreateUserName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示 、
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "编号",
          field: "number",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      selectTableData4: [], //收发地址 表格选择
      //  -----  查询  ------
      queryData4: {
        number: "",
        endCreateTime: "",
        endOutgoingTime: "",
        startCreateTime: "",
        startOutgoingTime: "",
        waybillNumber: "",
        customerName: "",
        carrierName: "",
        sendEmployeeId: "",
        businessDeptId: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes4: [
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "1",
          label: "结束日期",
        },
        {
          value: "2",
          label: "运单提货时间",
        },
      ],
      timeType4: "0", //  时间类型
      startTime_a4: "",
      endTime_a4: "",

      isShowDialog5: false,
      dialogTitle5: "发车取出明细",
      diaWidth5: "90%",
      tableData5: [],
      myTableHeard5: [
        {
          name: "发车批次号",
          field: "number",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发车时间",
          field: "departureTime",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "垫付人",
          field: "preparerEmployeeName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "费用合计",
          field: "financeOutAmount",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车牌号码",
          field: "carNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车型",
          field: "carType",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "任务票数",
          field: "taksCount",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "包含运单号",
          field: "waybillNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货城市",
          field: "receiveCityName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "总件数",
          field: "totalCount",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "总毛重kg",
          field: "totalGrossWeight",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "总净重kg",
          field: "totalNetWeight",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "总体积m³",
          field: "totalVolume",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "结算对象类型",
          field: "objectStatus",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "结算对象",
          field: "objectName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "付款方式",
          field: "paymentMethod",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机",
          field: "driverName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机电话",
          field: "driverPhone",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },


        {
          name: "类型",
          field: "departureTypeShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发车类型",
          field: "aaa",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "挂车号码",
          field: "trailerNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "调度状态",
          field: "dispatchStatusShow",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "申请报销状态",
          field: "applyReimburseStatus",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机身份证",
          field: "driverIdcard",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货员",
          field: "sendNotifierName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "随车人员",
          field: "carFollowPersonnelName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "总重量kg",
          field: "totalWeight",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车辆类型",
          field: "carCategory",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机属性",
          field: "driverAttribute",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "行驶里程数",
          field: "mileage",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开始里程数",
          field: "startMileage",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "结束里程数",
          field: "endMileage",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "完成时间",
          field: "completeTime",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      selectTableData5: [], //收发地址 表格选择
      //  -----  查询  ------
      queryData5: {
        number: "",
        endCreateTime: "",
        endDepartureTime: "",
        startDepartureTime: "",
        startCreateTime: "",
        waybillNumber: "",
        preparerEmployeeId: "",
        objectStatusConfDictId: "",
        objectName: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes5: [
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "1",
          label: "发车日期",
        },
      ],
      timeType5: "0", //  时间类型
      startTime_a5: "",
      endTime_a5: "",

      isShowDialog6: false,
      dialogTitle6: "车辆取出明细",
      diaWidth6: "90%",
      tableData6: [],
      myTableHeard6: [
        {
          name: "画像标签",
          field: "portraitLabel",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车牌号",
          field: "carNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车辆分类",
          field: "carCategoryName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车型",
          field: "carTypeName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车辆使用部门",
          field: "useDeptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "活动区域",
          field: "actionZone",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "任务状态",
          field: "taskStatusShow",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "启用状态",
          field: "carStatusShow",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "保养到期时间",
          field: "maintenanceDueTime",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "年检到期时间",
          field: "annualCheckEndTime",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "行驶证号",
          field: "drivingLicenseNo",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车架号码",
          field: "frameNumber",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "挂车号码",
          field: "trailerNumber",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发动机号",
          field: "engineNumber",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "营运证号",
          field: "operationCertificateNo",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "可载重量",
          field: "loadableCapacity",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "可载体积",
          field: "loadableVolume",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车辆皮重",
          field: "vehicleTare",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "保险单号",
          field: "policyNo",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "附加费证号",
          field: "surchargeCertificateNo",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机姓名",
          field: "driverName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机电话",
          field: "driverPhone",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "家庭电话",
          field: "driverTel",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "身份证号",
          field: "driverIdCard",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机住址",
          field: "driverAddress",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "驾驶证号",
          field: "driverLicenseNumber",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车主姓名",
          field: "ownerName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车主电话",
          field: "ownerPhone",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车主地址",
          field: "ownerAddress",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车属单位",
          field: "company",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "单位电话",
          field: "companyPhone",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "单位地址",
          field: "companyAddress",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "修改人",
          field: "updateUserName",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "修改时间",
          field: "updateTime",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      selectTableData6: [], //收发地址 表格选择
      //  -----  查询  ------
      queryData6: {
        carNumber: "",
      }, //  表单查询数据

      settlementMethodList: [],
      objectStatusList: [],
      CustomerListsYF: [],
      CustomerListsYF1: [],
      categoryNameList: [], //费项类型
      CategoryServiceList: [], //费项
      fileNameLists1: [],
      fileNameLists8: [],
      depList: [],
      fundAccountList: [],
      fundAccountListHx: [],
      writeoff_methodList: [],
      otherId: "",
      keyJumpt: "",

      initIds: [],
      initIdsLists: [],
      totalArr: [
        "amount",
        "planTakeFee",
        "planSendFee",
        "totalCount",
        "totalNetWeight",
        "totalGrossWeight",
        "totalVolume",
        "sendFee",
        "billingAmount",
        "totalFreight",
        "planFreight",
        "planOtherFee",
        "planTotalAmount",
        "basicFreight",
        "taksCount",
        "financeOutAmount",
        "totalWeight",
      ],
      employeeList: [],
      CarrierLists: [], //承运商列表
      // pageGroupName: "admin_waybill_finance_out_service_list", //  页面标识
      reportFiledsNumber: "admin_waybill_finance_out_service_list", // 动态 条件、表头
      isShowDialog7: false,
      dialogTitle7: "运单应付明细",
      diaWidth7: "90%",
      queryCondditionDatas: [], //查询列表动态数据

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据

      tabelHeadeTitle: [], //默认表头
      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      sortName: "模板", //  排序名
      selectLength: 0, //  显示的长度
      // totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要

      isShowDialog8: false,
      dialogTitle8: "核销",
      diaWidth8: "50%",
      queryData8: {
        financeId: "",
        financeNumber: "",
        settlementAmount: "",
        accountId: "",
        writeOffTime: "",
        writeoffComment: "",
        writeOffPics: [],
      },
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getConfDictValDownListApi("object_status");
    this.getConfDictValDownListApi("out_going_settlement_method"); //获取结算对象类型
    this.itemCategorChoose(); //费型类型下拉列表
    this.getDeptList();
    this.GetassetaccountList();
    this.runPageReportDetailsitemId("formula_billing_weight_down_list");
  },
  activated() {
    let { otherId, keyJumpt, reimbursementDirection, pageType } =
      this.$route.query;
    // 点击按钮进来的要清除页面数据
    if (pageType == "newPage") {
      this.otherId = "";
      this.DELArrys = [];
      this.tableData1 = [];
      this.fileNameLists1 = [];
      this.fileNameLists8 = [];
      this.objectStatusType = "";
      this.dialogFormDispatch = {
        amount: "",
        businessDeptId: "",
        fileIds: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        occurrenceTime: this.$TOOLS.getCurrentTime(),
        operationType: "SAVE",
        reimbursementDirection: "",
        remark: "",
        settlementAmount: "",
        settlementMethodConfDictId: "",
        writeoffMethod: "",
        zjAccount: "",
        waybills: [],
      };
    }
    if (keyJumpt) {
      this.keyJumpt = keyJumpt || "";
    }
    if (otherId) {
      this.otherId = otherId || "";
    }
    if (reimbursementDirection) {
      this.dialogFormDispatch.reimbursementDirection =
        reimbursementDirection || "";
      this.init();
    }
  },
  destroyed() {},
  methods: {
    changeWriteoffMethod(e) {
      if (e == "cai_wu:writeoff_method") {
        this.dialogFormDispatch.settlementAmount = "";
        this.dialogFormDispatch.zjAccount = "";
      }
    },
    amountInput(e) {
      this.dialogFormDispatch.settlementAmount = e;
    },
    onInputHW(index) {
      // let { reimbursementDirection } = this.dialogFormDispatch;
      let keyset = "documentNumber";
      // if (
      //   reimbursementDirection ==
      //   "bill_tms_waybill_split_v3:reimbursement_direction"
      // ) {
      //   //运单
      //   keyset = "waybillNumber";
      // } else if (reimbursementDirection == "car_v3:reimbursement_direction") {
      //   // 车辆
      //   // carNumber
      //   keyset = "carNumber";
      // } else if (
      //   reimbursementDirection ==
      //   "bill_tms_waybill_outgoing_v3:reimbursement_direction"
      // ) {
      //   // 外发
      //   // number
      //   keyset = "number";
      // } else if (
      //   reimbursementDirection == "bill_tms_dispatch_v3:reimbursement_direction"
      // ) {
      //   // 发车
      //   // number
      //   keyset = "number";
      // }
      if (this.initIds.includes(this.tableData1[index][keyset])) {
        this.tableData1[index].operationType = "UPDATE";
      }
    },
    // 获取承运商列表
    getCarrierList(carrierName) {
      console.log(carrierName);
      this.$API
        .CarrierList({
          pageStart: 1,
          pageTotal: 200,
          carrierName: carrierName || "",
        })
        .then((res) => {
          this.CarrierLists = res.data.result.data || [];
        });
    },
    //员工、部门、外发网点
    focusMethod(key, keys) {
      if (this[keys].length == 0) {
        this.remoteMethod("", key, keys);
      }
    },
    // //员工、部门、外发网点
    // changeMethod(e, arrs, keys) {
    //   let curs = this[arrs].filter((item) => item.documentId == e);
    //   if (keys == "intoDeptName") {
    //     this.rukuPlanReq[keys] = (curs.length && curs[0].name) || "";
    //   } else {
    //     this.commandReq[keys] = (curs.length && curs[0].name) || "";
    //   }
    // },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      return this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          this[keys] = arrs;
        });
    },
    handleSizeChange3(val) {
      //  分页
      this.pageTotal3 = val;
      this.clickQuery3();
    },
    handleCurrentChange3(val) {
      //  分页
      this.pageStart3 = val;
      this.clickQuery3();
    },
    handleSizeChange4(val) {
      //  分页
      this.pageTotal4 = val;
      this.clickQuery4();
    },
    handleCurrentChange4(val) {
      //  分页
      this.pageStart4 = val;
      this.clickQuery4();
    },
    handleSizeChange5(val) {
      //  分页
      this.pageTotal5 = val;
      this.clickQuery5();
    },
    handleCurrentChange5(val) {
      //  分页
      this.pageStart5 = val;
      this.clickQuery5();
    },

    handleSizeChange6(val) {
      //  分页
      this.pageTotal6 = val;
      this.clickQuery6();
    },
    handleCurrentChange6(val) {
      //  分页
      this.pageStart6 = val;
      this.clickQuery6();
    },

    // 计算基本运费
    countBaseFee() {
      if (!this.tableData1.length) {
        this.$message.error("明细数据不能为空");
        return false;
      }
      if (
        this.dialogFormDispatch.reimbursementDirection ==
        "bill_tms_waybill_outgoing_v3:reimbursement_direction"
      ) {
        this.dialogFormDispatch.amount = this.sumpubGGG(
          this.tableData1,
          "totalFreight",
          0
        );
      }
      if (
        this.dialogFormDispatch.reimbursementDirection ==
        "bill_tms_waybill_v3_finance_out_service:reimbursement_direction"
      ) {
        this.dialogFormDispatch.amount = this.sumpubGGG(
          this.tableData1,
          "amount",
          0
        );
      }
      if (
        this.dialogFormDispatch.reimbursementDirection ==
        "bill_tms_dispatch_v3:reimbursement_direction"
      ) {
        this.dialogFormDispatch.amount = this.sumpubGGG(
          this.tableData1,
          "financeOutAmount",
          0
        );
      }
    },
    // 获取员工 employee
    getemployee(name) {
      return this.$API
        .wtl_getObjectUserDownList({
          key: "employee",
          name: name || "",
          pageStart: 1,
          pageTotal: 50,
        })
        .then((res) => {
          this.employeeList55 = res.data.result.data || [];
        });
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        if (this.totalArr.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return this.$TOOLS.mathToFixed(this.$TOOLS.add(prev, curr), 2);
              } else {
                return prev;
              }
            }, 0);
            sums[index] += "";
          } else {
            sums[index] = "";
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    // 动态接口获取下拉列表
    runPageReportDetailsitemId(number, array) {
      // customer_channel_down_list => 客户报价方式下拉列表
      // 参数key:
      // customerId(客户id 必填)
      // channelName(报价方式名称 非必填)

      // customer_dispatch_channel_down_list => 客户线路报价下拉列表(报价到货区域)
      // 参数key:
      // channelId(报价方式id 必填)
      // offerName(线路报价名称 非必填)

      // formula_billing_weight_down_list => 获取计费重量公式下拉列表

      this.$API
        .runPageReportDetails({
          number: number,
          conditionReqs: array || [],
        })
        .then((res) => {
          let datas = res.data.result.datas || [];
          if (number == "formula_billing_weight_down_list") {
            // 计费方式
            this.out_going_billing_method_list = datas;
          }
        });
    },
    async init() {
      let params = {
        otherId: this.otherId,
      };
      await this.getConfDictValDownListApi("settlement_method"); //获取付款方式
      await this.getStatusValListApi();
      if (this.otherId) {
        await this.$API.getExpenseDetail(params).then((res) => {
          if (res.data.status === "success") {
            let datas = res.data.result;
            let {
              amount,
              businessDeptId,
              fileIds,
              itemCategoryId,
              itemCategoryName,
              itemServiceId,
              itemServiceName,
              objectName,
              objectNumber,
              objectStatusConfDictId,
              occurrenceTime,
              reimbursementDirection,
              remark,
              settlementAmount,
              settlementMethodConfDictId,
              writeoffMethod,
              zjAccount,
            } = datas;
            this.objectStatusList.forEach((item) => {
              if (item.confDictId == objectStatusConfDictId) {
                this.objectStatusType = item.key;
                this.changeObjestStatus(this.objectStatusType);
              }
            });
            this.changeItemCategoryId(itemCategoryId);
            this.dialogFormDispatch = {
              amount,
              businessDeptId,
              fileIds: [],
              itemCategoryId,
              itemCategoryName,
              itemServiceId,
              itemServiceName,
              objectName,
              objectNumber,
              objectStatusConfDictId,
              occurrenceTime,
              operationType: "SAVE",
              reimbursementDirection,
              remark,
              settlementAmount,
              settlementMethodConfDictId,
              writeoffMethod,
              zjAccount,
              waybills: [],
            };
            this.fileNameLists1 =
              (fileIds &&
                fileIds.length &&
                fileIds.map((n) => {
                  return {
                    name: n.fileId,
                    url: n.fileUrl,
                  };
                })) ||
              [];
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
      }
      let { reimbursementDirection } = this.dialogFormDispatch;
      console.log(reimbursementDirection)
      if (
        reimbursementDirection ==
        "bill_tms_waybill_split_v3:reimbursement_direction"
      ) {
        // 运单
        this.myTableHeard1 = this.myTableHeard1yd;
        if (this.otherId) {
          await this.$API.getExpenseDetailWaybill(params).then((res) => {
            if (res.data.status === "success") {
              this.tableData1 = res.data.result || [];
              this.tableData1.forEach((item) => {
                item.operationType = "UNCHANGED";
              });
              this.initIds = this.tableData1.map((n) => {
                // n.waybillNumber ||
                return n.documentNumber;
              });
              this.initIdsLists = JSON.parse(
                JSON.stringify(res.data.result || [])
              );
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
        }
      } else if (reimbursementDirection == "car_v3:reimbursement_direction") {
        // 车辆
        this.myTableHeard1 = this.myTableHeard1cl;
        if (this.otherId) {
          await this.$API.getExpenseDetailCar(params).then((res) => {
            if (res.data.status === "success") {
              this.tableData1 = res.data.result || [];
              this.tableData1.forEach((item) => {
                item.operationType = "UNCHANGED";
              });
              this.initIds = this.tableData1.map((n) => {
                // n.carNumber ||
                return n.documentNumber;
              });
              this.initIdsLists = JSON.parse(
                JSON.stringify(res.data.result || [])
              );
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
        }
      } else if (
        reimbursementDirection ==
        "bill_tms_waybill_outgoing_v3:reimbursement_direction"
      ) {
        //外发 number
        console.log('外发 number')
        this.myTableHeard1 = this.myTableHeard1wf;
        if (this.otherId) {
          await this.$API.getExpenseDetailOutgoing(params).then((res) => {
            if (res.data.status === "success") {
              this.tableData1 = res.data.result || [];
              this.tableData1.forEach((item) => {
                item.operationType = "UNCHANGED";
              });
              this.initIds = this.tableData1.map((n) => {
                // n.number ||
                return n.documentNumber;
              });
              this.initIdsLists = JSON.parse(
                JSON.stringify(res.data.result || [])
              );
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
        }
      } else if (
        reimbursementDirection == "bill_tms_dispatch_v3:reimbursement_direction"
      ) {
        //发车 number
        console.log('发车 number')
        this.myTableHeard1 = this.myTableHeard1fc;
        if (this.otherId) {
          await this.$API.getExpenseDetailDispatch(params).then((res) => {
            if (res.data.status === "success") {
              this.tableData1 = res.data.result || [];
              this.tableData1.forEach((item) => {
                item.operationType = "UNCHANGED";
              });
              this.initIds = this.tableData1.map((n) => {
                // n.number ||
                return n.documentNumber;
              });
              this.initIdsLists = JSON.parse(
                JSON.stringify(res.data.result || [])
              );
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
        }
      } else if (
        reimbursementDirection ==
        "bill_tms_waybill_v3_finance_out_service:reimbursement_direction"
      ) {
        //运单应付
        console.log('运单应付')
        this.initTable();
        if (this.otherId) {
          await this.$API
            .getExpenseDetailWaybillFinanceOut(params)
            .then((res) => {
              if (res.data.status === "success") {
                this.tableData1 = res.data.result || [];
                this.tableData1.forEach((item) => {
                  item.operationType = "UNCHANGED";
                });
                this.initIds = this.tableData1.map((n) => {
                  // n.number ||
                  return n.documentNumber;
                });
                this.initIdsLists = JSON.parse(
                  JSON.stringify(res.data.result || [])
                );
              } else {
                this.$message.error(`${res.data.message}---综合查询列表`);
              }
            });
        }
      }
    },
    onClick(key) {
      switch (key) {
        case 1:
          // 批量一级审核
          this.$confirm("确定要通过一级审核吗? 请谨慎操作", "提示:")
            .then((res) => {
              this.$API
                .oneApprove({
                  otherIds: [this.otherId],
                })
                .then((res) => {
                  this.$message.success(res.data.message || "操作成功");
                  this.$router.push({
                    path: "/FinancialManagement/ExpenseReimbursement",
                  });
                });
            })
            .catch((err) => {});
          break;
        case 2:
          // 批量二级审核
          this.$confirm("确定要通过二级审核吗? 请谨慎操作", "提示:")
            .then((res) => {
              this.$API
                .twoApprove({
                  otherIds: [this.otherId],
                })
                .then((res) => {
                  this.$message.success(res.data.message || "操作成功");
                  this.$router.push({
                    path: "/FinancialManagement/ExpenseReimbursement",
                  });
                });
            })
            .catch((err) => {});
          break;

        default:
          break;
      }
    },
    // 选择结算对象类型(应收
    changeObjestStatusYS(e) {
      this.queryData5.objectName = "";
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.confDictId == e) {
            this.objectStatusType1 = item.key;
          }
        });
        //
        this.getObjectUserDownListYf1();
      } else {
        this.queryData5.objectName = "";
        this.queryData5.objectNumber = "";
        this.queryData5.objectStatusConfDictId = "";
      }
    },
    // 提交
    async submit(operationType) {
      let { reimbursementDirection } = this.dialogFormDispatch;

      let gg_vv = "";
      if (
        reimbursementDirection ==
        "bill_tms_waybill_split_v3:reimbursement_direction"
      ) {
        //运单 amount
        gg_vv = "amount";
      } else if (reimbursementDirection == "car_v3:reimbursement_direction") {
        // 车辆 amount
        gg_vv = "amount";
      } else if (
        reimbursementDirection ==
        "bill_tms_waybill_outgoing_v3:reimbursement_direction"
      ) {
        // 外发 totalFreight
        gg_vv = "totalFreight";
      } else if (
        reimbursementDirection == "bill_tms_dispatch_v3:reimbursement_direction"
      ) {
        // 发车 financeOutAmount
        gg_vv = "financeOutAmount";
      } else if (
        reimbursementDirection ==
        "bill_tms_waybill_v3_finance_out_service:reimbursement_direction"
      ) {
        // 运单应付 amount
        gg_vv = "amount";
      }
      if (gg_vv) {
        let sumsvv = this.sumpubGGG(this.tableData1, gg_vv, 0);
        if (sumsvv != this.dialogFormDispatch.amount) {
          this.$message.error(`发生金额跟明细合计金额不一致`);
          return false;
        }
      }

      let fileIds = this.fileNameLists1.map((item) => {
        return item.name;
      });
      this.dialogFormDispatch.fileIds = fileIds;
      this.dialogFormDispatch.operationType = operationType;
      let waybills = [];
      let initwaybills = [];
      // let arrs = [...this.tableData1, this.DELArrys] || [];
      // let arrs = this.tableData1.concat(this.DELArrys);
      // this.initIdsLists
      let arrs = this.tableData1;
      let initarrs = this.initIdsLists;

      arrs.forEach((element) => {
        if (
          reimbursementDirection ==
          "bill_tms_waybill_split_v3:reimbursement_direction"
        ) {
          //运单
          // waybillNumber element.orderNumber ||
          waybills.push({
            amount: element.amount,
            documentNumber: element.documentNumber,
            documentStatus: "bill_tms_waybill_split_v3:document_status",
            operationType: element.operationType || "",
          });
        } else if (reimbursementDirection == "car_v3:reimbursement_direction") {
          // 车辆
          // carNumber element.carNumber ||
          waybills.push({
            amount: element.amount,
            documentNumber: element.documentNumber,
            documentStatus: "car_v3:document_status",
            operationType: element.operationType || "",
          });
        } else if (
          reimbursementDirection ==
          "bill_tms_waybill_outgoing_v3:reimbursement_direction"
        ) {
          // 外发
          // number element.number ||
          waybills.push({
            amount: element.amount,
            documentNumber: element.documentNumber,
            documentStatus: "bill_tms_waybill_outgoing_v3:document_status",
            operationType: element.operationType || "",
          });
        } else if (
          reimbursementDirection ==
          "bill_tms_dispatch_v3:reimbursement_direction"
        ) {
          // 发车
          // number element.number ||
          waybills.push({
            amount: element.amount,
            documentNumber: element.documentNumber,
            documentStatus: "bill_tms_dispatch_v3:document_status",
            operationType: element.operationType || "",
          });
        } else if (
          reimbursementDirection ==
          "bill_tms_waybill_v3_finance_out_service:reimbursement_direction"
        ) {
          // 发车
          // number  element.number ||
          waybills.push({
            amount: element.amount,
            documentNumber: element.documentNumber,
            documentStatus:
              "bill_tms_waybill_v3_finance_out_service:document_status",
            operationType: element.operationType || "",
          });
        }
      });

      initarrs.forEach((element) => {
        if (
          reimbursementDirection ==
          "bill_tms_waybill_split_v3:reimbursement_direction"
        ) {
          //运单
          // waybillNumber element.orderNumber ||
          initwaybills.push({
            amount: element.amount,
            documentNumber: element.documentNumber,
            documentStatus: "bill_tms_waybill_split_v3:document_status",
            operationType: element.operationType || "",
          });
        } else if (reimbursementDirection == "car_v3:reimbursement_direction") {
          // 车辆
          // carNumber element.carNumber ||
          initwaybills.push({
            amount: element.amount,
            documentNumber: element.documentNumber,
            documentStatus: "car_v3:document_status",
            operationType: element.operationType || "",
          });
        } else if (
          reimbursementDirection ==
          "bill_tms_waybill_outgoing_v3:reimbursement_direction"
        ) {
          // 外发
          // number element.number ||
          initwaybills.push({
            amount: element.amount,
            documentNumber: element.documentNumber,
            documentStatus: "bill_tms_waybill_outgoing_v3:document_status",
            operationType: element.operationType || "",
          });
        } else if (
          reimbursementDirection ==
          "bill_tms_dispatch_v3:reimbursement_direction"
        ) {
          // 发车
          // number  element.number ||
          initwaybills.push({
            amount: element.amount,
            documentNumber: element.documentNumber,
            documentStatus: "bill_tms_dispatch_v3:document_status",
            operationType: element.operationType || "",
          });
        } else if (
          reimbursementDirection ==
          "bill_tms_waybill_v3_finance_out_service:reimbursement_direction"
        ) {
          // 发车
          // number element.number ||
          initwaybills.push({
            amount: element.amount,
            documentNumber: element.documentNumber,
            documentStatus:
              "bill_tms_waybill_v3_finance_out_service:document_status",
            operationType: element.operationType || "",
          });
        }
      });

      // if (waybills.length) {
      waybills.forEach((element) => {
        if (!this.initIds.includes(element.documentNumber)) {
          // element.operationType = "UPDATE";
          element.operationType = "ADD";
        }
      });
      let arrsgg = [];
      initwaybills.forEach((element) => {
        if (
          !waybills.find((n) => {
            return n.documentNumber == element.documentNumber;
          })
        ) {
          element.operationType = "DEL";
          arrsgg.push(element);
        }
      });
      this.dialogFormDispatch.waybills = [...waybills, ...arrsgg];
      // }
      this.dialogFormDispatch.settlementAmount =
        this.dialogFormDispatch.settlementAmount || 0;
      if (this.otherId) {
        // if (waybills.length) {
        //   waybills.forEach((element) => {
        //     if (this.initIds.includes(element.documentNumber)) {
        //       element.operationType = "UPDATE";
        //     } else {
        //       element.operationType = "ADD";
        //     }
        //   });
        //   this.dialogFormDispatch.waybills = waybills;
        // }
        this.dialogFormDispatch.otherId = this.otherId;

        if (operationType == "GZBHX") {
          delete this.dialogFormDispatch.operationType;
          await this.$API
            .postingExpense(this.dialogFormDispatch)
            .then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message || "操作成功");
                this.isShowDialog8 = true;

                this.queryData8.financeId = res.data.result.financeId || "";
                this.queryData8.financeNumber =
                  res.data.result.financeNumber || "";
                this.queryData8.settlementAmount =
                  res.data.result.settlementAmount || "";
                // this.$TOOLS.closePage();
                // this.$router.push({
                //   path: "/FinancialManagement/ExpenseReimbursement",
                //   query: {
                //     isreload: "isreload",
                //   },
                // });
              } else {
                this.$message.error(`${res.data.message}`);
              }
            });
        } else {
          // 保存并过账
          await this.$API.updateExpense(this.dialogFormDispatch).then((res) => {
            if (res.data.status === "success") {
              this.$message.success(res.data.message || "操作成功");
              this.$TOOLS.closePage();
              this.$router.push({
                path: "/FinancialManagement/ExpenseReimbursement",
                query: {
                  isreload: "isreload",
                },
              });
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
        }
      } else {
        // if (waybills.length) {
        //   this.dialogFormDispatch.waybills = waybills;
        // }
        await this.$API.addExpense(this.dialogFormDispatch).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message || "操作成功");
            this.$TOOLS.closePage();
            this.$router.push({
              path: "/FinancialManagement/ExpenseReimbursement",
              query: {
                isreload: "isreload",
              },
            });
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
      }
    },

    // 获取状态展示值
    getStatusValListApi() {
      return this.$API
        .getStatusValList({
          tableAndFieldName: "bill_finance_other_out_v3.writeoff_method",
        })
        .then((res) => {
          // 核销方式
          this.writeoff_methodList = res.data.result || [];
          this.dialogFormDispatch.writeoffMethod =
            (this.writeoff_methodList.length &&
              this.writeoff_methodList[0].statusVal) ||
            "";
        });
    },
    // 获取资金账号列表
    GetassetaccountList() {
      // this.$API.assetaccountList().then((res) => {
      //   if (res.data.status === "success") {
      //     let result = res.data.result?.data || [];
      //     this.fundAccountList = result;
      //   } else {
      //     this.$message.error(`${res.data.message}`);
      //   }
      // });
      this.$API
        .runPageReport({
          number: "down_list_jie_zhi_assetaccount",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.fundAccountList = res.data.result.datas.data || [];
        });
    },
    getfundAccountListHx(e) {
      console.log("e", e);
      if (!e) {
        return false;
      }
      this.getfundAccountListHxName();
    },
    getfundAccountListHxName(val) {
      this.$API
        .runPageReport({
          number: "down_list_assetaccount",
          conditionReqs: [
            {
              conditonKey: "account",
              conditonVal: val || "",
            },
          ],
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.fundAccountListHx = res.data.result.datas.data || [];
        });
    },

    // 获取组织架构列表
    getDeptList() {
      this.$API
        .wtl_getDeptList({
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.depList = res.data.result.data || [];
        });
    },
    // 选择图片(装货确认)
    changeFileList_zh(array) {
      this.fileNameLists1 = array;
    },
    // 选择图片(核销)
    changeFileList8(array) {
      this.fileNameLists8 = array;
    },
    // 选择结算对象类型
    changeObjestStatus(e) {
      this.dialogFormDispatch.objectName = "";
      this.dialogFormDispatch.objectNumber = "";
      this.dialogFormDispatch.objectStatusConfDictId = "";
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.key == e) {
            this.dialogFormDispatch.objectStatusConfDictId = item.confDictId;
          }
        });
        this.getObjectUserDownListYf();
      }
    },
    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.dialogFormDispatch.objectNumber = item.number;
          }
        });
      }
    },
    changeobjectName1(e) {
      if (!e) {
        this.getObjectUserDownListYf1();
      } else {
        this.CustomerListsYF1.forEach((item) => {
          if (item.name === e) {
            this.queryData5.objectNumber = item.number;
          }
        });
      }
    },

    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf1(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: this.objectStatusType1 || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF1 = res.data.result.data || [];
        });
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: this.objectStatusType || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || [];
        });
    },
    // 费型类型下拉列表
    itemCategorChoose(categoryName) {
      this.$API
        .itemCategorChoose({ categoryName: categoryName })
        .then((res) => {
          this.categoryNameList = res.data.result || [];
        });
    },
    //选择费项类型()
    changeItemCategoryId(e) {
      this.dialogFormDispatch.itemServiceId = "";
      this.dialogFormDispatch.itemServiceName = "";
      if (e) {
        this.wtl_itemServiceListAll(e);
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogFormDispatch.itemCategoryName = item.categoryName;
          }
        });
      }
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAll(e, directionStatus) {
      this.$API
        .wtl_getCategoryServiceList({
          categoryId: e || "",
          directionStatus: directionStatus || "",
        })
        .then((res) => {
          this.CategoryServiceList = res.data.result || [];
        });
    },
    //选择费项
    changeItemServiceId(e) {
      // this.dialogFormDispatch.amount = "";
      this.dialogFormDispatch.itemServiceName = "";
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            // this.dialogFormDispatch.amount = item.unitPrice;
            this.dialogFormDispatch.itemServiceName = item.title;
          }
        });
      }
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownListApi(type) {
      return this.$COMAPI.getConfDictValDownList(type).then((res) => {
        if (type == "settlement_method") {
          // 获取付款方式
          this.settlementMethodList = res || [];
          this.dialogFormDispatch.settlementMethodConfDictId =
            (this.settlementMethodList.length &&
              this.settlementMethodList[0].confDictId) ||
            "";
        }
        if (type == "object_status") {
          // 获取结算对象类型
          this.objectStatusList = res || [];
        }
        // 外发结算方式
        if (type == "out_going_settlement_method") {
          this.out_going_settlement_method_list = res || [];
        }
      }); //送货方式
    },
    handleSelectionChange1(e) {
      this.selectTableData1 = e;
    },
    clickAdd() {
      this.isShowDialog2 = true;
    },
    async clickRetrieve() {
      let startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
      let endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;
      let { reimbursementDirection } = this.dialogFormDispatch;
      if (
        reimbursementDirection ==
        "bill_tms_waybill_split_v3:reimbursement_direction"
      ) {
        //运单
        // waybillNumber
        this.queryData3 = {
          waybillNumber: "",
          startBusinessTime: "",
          startCreateTime: "",
          endBusinessTime: "",
          endCreateTime: "",
        };
        this.startTime_a3 = startTime_a;
        this.endTime_a3 = endTime_a;
        // await this.clickQuery3(1);
        this.tableData3 = [];
        this.isShowDialog3 = true;
      } else if (reimbursementDirection == "car_v3:reimbursement_direction") {
        // 车辆
        // carNumber
        this.queryData6 = {
          carNumber: "",
        };
        // await this.clickQuery6();
        this.tableData6 = [];
        this.isShowDialog6 = true;
      } else if (
        reimbursementDirection ==
        "bill_tms_waybill_outgoing_v3:reimbursement_direction"
      ) {
        // 外发
        // number
        this.queryData4 = {
          number: "",
          endCreateTime: "",
          endOutgoingTime: "",
          startCreateTime: "",
          startOutgoingTime: "",
          waybillNumber: "",
          customerName: "",
          carrierName: "",
          sendEmployeeId: "",
          businessDeptId: "",
        };
        this.startTime_a4 = startTime_a;
        this.endTime_a4 = endTime_a;
        // await this.clickQuery4(1);
        this.tableData4 = [];
        this.isShowDialog4 = true;
      } else if (
        reimbursementDirection == "bill_tms_dispatch_v3:reimbursement_direction"
      ) {
        // 发车
        // number
        this.queryData5 = {
          number: "",
          endCreateTime: "",
          endDepartureTime: "",
          startDepartureTime: "",
          startCreateTime: "",
          waybillNumber: "",
          preparerEmployeeId: "",
          objectStatusConfDictId: "",
          objectName: "",
        };
        this.startTime_a5 = startTime_a;
        this.endTime_a5 = endTime_a;
        // await this.clickQuery5(1);
        this.tableData5 = [];
        this.isShowDialog5 = true;
      } else if (
        reimbursementDirection ==
        "bill_tms_waybill_v3_finance_out_service:reimbursement_direction"
      ) {
        // 运单应付
        this.tableData = [];
        this.isShowDialog7 = true;
      }
    },
    clickDel() {
      if (this.selectTableData1.length < 1) {
        this.$message.warning("请选择需要操作的数据");
        return false;
      }
      let { reimbursementDirection } = this.dialogFormDispatch;
      let keyset = "";
      if (
        reimbursementDirection ==
        "bill_tms_waybill_split_v3:reimbursement_direction"
      ) {
        //运单
        keyset = "waybillNumber";
      } else if (reimbursementDirection == "car_v3:reimbursement_direction") {
        // 车辆
        // carNumber
        keyset = "carNumber";
      } else if (
        reimbursementDirection ==
        "bill_tms_waybill_outgoing_v3:reimbursement_direction"
      ) {
        // 外发
        // number
        keyset = "number";
      } else if (
        reimbursementDirection == "bill_tms_dispatch_v3:reimbursement_direction"
      ) {
        // 发车
        // number
        keyset = "number";
      } else if (
        reimbursementDirection ==
        "bill_tms_waybill_v3_finance_out_service:reimbursement_direction"
      ) {
        // 运单应付
        // number
        keyset = "number";
      }
      // let ids = [];
      // this.selectTableData1.forEach((item) => {
      //   ids.push(item[keyset]);
      // });
      let deleteIndex = [];
      this.tableData1.filter((item, index) => {
        if (
          this.selectTableData1
            .map((n) => {
              return n[keyset];
            })
            .includes(item[keyset])
        ) {
          deleteIndex.push(index);
        }
      });
      if (deleteIndex.length > 0) {
        for (let i = deleteIndex.length - 1; i >= 0; i--) {
          this.tableData1.splice(deleteIndex[i], 1);
        }
      }
    },
    clickCostSharing() {
      if (!this.dialogFormDispatch.amount) {
        this.$message.warning("请输入发生金额");
        return false;
      }
      if (!this.tableData1.length) {
        this.$message.warning("请选择运单明细");
        return false;
      }
      let { reimbursementDirection } = this.dialogFormDispatch;
      if (
        reimbursementDirection ==
        "bill_tms_waybill_split_v3:reimbursement_direction"
      ) {
        //运单
        this.isShowDialog1 = true;
      } else if (reimbursementDirection == "car_v3:reimbursement_direction") {
        // 车辆
        // carNumber
        let { amount } = this.dialogFormDispatch;
        let cursend = this.$TOOLS
          .divide(amount, this.tableData1.length)
          .toFixed(2);
        let arrs = _.cloneDeep(this.tableData1);
        arrs.forEach((element) => {
          element.amount = cursend;
        });
        this.tableData1 = arrs;
      }
    },
    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.dialogForm1 = {
        formulaBillingWeightId: "",
      };
    },
    //  弹窗确认保存事件
    async diaConfirmBtn1() {
      let { amount } = this.dialogFormDispatch;
      let arrs = [];
      let tables = _.cloneDeep(this.tableData1);
      const promisemap = tables.map(async (element, index) => {
        let objj = await this.billWeightCalculationById(index);
        arrs.push(objj);
      });
      await Promise.all(promisemap);
      let sums = this.sumpubGGG(arrs, "value", 0);
      arrs.forEach((element) => {
        let getbasicFreight = this.$TOOLS.mathToFixed(
          this.$TOOLS.mul(this.$TOOLS.divide(element.value, sums), amount)
        );
        tables[element.key].amount = getbasicFreight;
      });
      this.tableData1 = tables;
      this.isShowDialog1 = false;
    },
    // 运费计算(自定义选择报价)
    async billWeightCalculationById(index) {
      let grossWeight = this.curBillingSums("totalGrossWeight", index);
      let netWeight = this.curBillingSums("totalNetWeight", index);
      let packageCount = this.curBillingSums("totalCount", index);
      let volume = this.curBillingSums("totalVolume", index);
      let param = {
        formulaBillingWeightId: this.dialogForm1.formulaBillingWeightId,
        grossWeight: grossWeight || 0,
        netWeight: netWeight || 0,
        packageCount: packageCount || 0,
        volume: volume || 0,
        // channelDivisor: this.goodsInfoList[0].itemReqs[0].volumeDivisor || 0,
      };
      return this.$API.billWeightCalculationById(param).then((res) => {
        let datas = res.data.result || {};
        return {
          key: index,
          value: Number(datas.billingWeight) || 0,
        };
      });
    },
    curBillingSums(key, index) {
      // 计算 运费均摊
      return this.tableData1[index][key];
    },
    sumpubGGG(arr, key, tofid = 2) {
      return arr
        .map((n) => {
          return n[key] || 0;
        })
        .reduce((prev, curr) => this.$TOOLS.add(prev, curr));
    },
    // diaConfirmBtn1() {
    // let { amount } = this.dialogFormDispatch;
    // let cursBillingId = this.dialogForm1.formulaBillingWeightId;
    // let curBilling = this.out_going_billing_method_list.filter((n) => {
    //   return n.confDictId == cursBillingId;
    // })[0].key;
    // switch (curBilling) {
    //   case "按票数":
    //     let arrs = _.cloneDeep(this.tableData1);
    //     let cursend = this.$TOOLS.divide(amount, arrs.length).toFixed(2);
    //     arrs.forEach((element) => {
    //       element.amount = cursend;
    //     });
    //     this.tableData1 = arrs;
    //     break;
    //   case "按件数":
    //     this.curBillingSums("totalCount");
    //     break;
    //   case "按毛重":
    //     this.curBillingSums("totalGrossWeight");
    //     break;
    //   case "按净重":
    //     this.curBillingSums("totalNetWeight");
    //     break;
    //   case "按体积":
    //     this.curBillingSums("totalVolume");
    //     break;
    //   default:
    //     break;
    // }
    // this.isShowDialog1 = false;
    // },
    sumpub(arr, key, tofid = 2) {
      let num =
        arr
          .map((n) => {
            return n[key];
          })
          .reduce((prev, curr) => this.$TOOLS.add(prev, curr)) * 1;
      return this.$TOOLS.mathToFixed(num, tofid);
    },
    // curBillingSums(key) {
    //   // 计算 运费均摊
    //   let { amount } = this.dialogFormDispatch;
    //   let arrs = _.cloneDeep(this.tableData1);
    //   let sum = this.sumpub(arrs, key, 0);
    //   console.log(arrs);
    //   arrs.forEach((element, index) => {
    //     console.log(element[key]);
    //     element.amount =
    //       element[key] == 0
    //         ? ""
    //         : this.$TOOLS.mathToFixed(
    //             this.$TOOLS.mul(this.$TOOLS.divide(element[key], sum), amount)
    //           );
    //   });
    //   this.tableData1 = arrs;
    //   this.$message.success("自动均摊成功");
    // },
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.queryData3 = {
        waybillNumber: "",
        startBusinessTime: "",
        startCreateTime: "",
        endBusinessTime: "",
        endCreateTime: "",
      };
      this.queryData4 = {
        number: "",
        endCreateTime: "",
        endOutgoingTime: "",
        startCreateTime: "",
        startOutgoingTime: "",
        waybillNumber: "",
        customerName: "",
        carrierName: "",
        sendEmployeeId: "",
        businessDeptId: "",
      };
      this.queryData5 = {
        number: "",
        endCreateTime: "",
        endDepartureTime: "",
        startDepartureTime: "",
        startCreateTime: "",
        waybillNumber: "",
        preparerEmployeeId: "",
      };
      this.queryData6 = {
        carNumber: "",
      };
      this.waybillNumberList = [];
      this.carNumberList = [];
      this.outgoingNumberList = [];
      this.fcnumberList = [];
    },
    //运单
    focusMetho_waybillNumber() {
      if (this.waybillNumberList.length == 0) {
        this.remoteMethod_waybillNumber("");
      }
    },
    remoteMethod_waybillNumber(name) {
      this.queryData3.waybillNumber = name;
      this.$API
        .wtl_getWaybillList({
          ...this.queryData3,
        })
        .then((res) => {
          if (res.data.status === "success") {
            this.waybillNumberList = res.data.result.data || [];
          } else {
            this.$message.error(`${res.data.message}`);
          }
        });
    },

    //车辆
    focusMetho_carNumber() {
      if (this.carNumberList.length == 0) {
        this.remoteMethod_carNumber("");
      }
    },
    remoteMethod_carNumber(name) {
      this.queryData6.carNumber = name;
      this.$API
        .CarArchiveList({
          ...this.queryData6,
        })
        .then((res) => {
          if (res.data.status === "success") {
            this.carNumberList = res.data.result.data || [];
          } else {
            this.$message.error(`${res.data.message}`);
          }
        });
    },

    //外发
    focusMetho_outgoingNumber() {
      if (this.outgoingNumberList.length == 0) {
        this.remoteMethod_outgoingNumber("");
      }
    },
    remoteMethod_outgoingNumber(name) {
      this.queryData4.number = name;
      this.$API
        .getOutgoingList({
          ...this.queryData4,
        })
        .then((res) => {
          if (res.data.status === "success") {
            this.outgoingNumberList = res.data.result.data || [];
          } else {
            this.$message.error(`${res.data.message}`);
          }
        });
    },
    //发车
    focusMetho_fcnumber() {
      if (this.fcnumberList.length == 0) {
        this.remoteMethod_fcnumber("");
      }
    },
    remoteMethod_fcnumber(name) {
      this.queryData5.number = name;
      this.$API
        .wtl_getDispatchList({
          ...this.queryData5,
        })
        .then((res) => {
          if (res.data.status === "success") {
            this.fcnumberList = res.data.result.data || [];
          } else {
            this.$message.error(`${res.data.message}`);
          }
        });
    },
    //  弹窗确认保存事件
    diaConfirmBtn2() {
      let { reimbursementDirection } = this.dialogFormDispatch;
      if (
        reimbursementDirection ==
        "bill_tms_waybill_split_v3:reimbursement_direction"
      ) {
        //运单 waybillNumber
        return this.$API
          .wtl_getWaybillList({
            ...this.queryData3,
          })
          .then((res) => {
            if (res.data.status === "success") {
              let datas = res.data.result.data || [];
              if (datas.length) {
                let cursnum = datas[0].documentNumber;
                if (
                  this.tableData1
                    .map((n) => {
                      return n.documentNumber;
                    })
                    .includes(cursnum)
                ) {
                  this.$message.error(
                    `运单 ${cursnum} 添加重复，请输入新的运单号`
                  );
                  return false;
                }
                datas[0].operationType = "ADD";
                this.tableData1.push(datas[0]);
                console.log("运单新增", this.tableData1);
                this.isShowDialog2 = false;
              } else {
                this.$message.error(`没有查询到运单 `);
              }
            } else {
              this.$message.error(`${res.data.message}`);
            }
          });
      } else if (reimbursementDirection == "car_v3:reimbursement_direction") {
        // 车辆 carNumber
        return this.$API
          .CarArchiveList({
            ...this.queryData6,
          })
          .then((res) => {
            if (res.data.status === "success") {
              let datas = res.data.result.data || [];
              if (datas.length) {
                let cursnum = datas[0].documentNumber;
                if (
                  this.tableData1
                    .map((n) => {
                      return n.documentNumber;
                    })
                    .includes(cursnum)
                ) {
                  this.$message.error(
                    `车牌号 ${cursnum} 添加重复，请输入新的车牌号`
                  );
                  return false;
                }
                datas[0].operationType = "ADD";
                this.tableData1.push(datas[0]);
                this.isShowDialog2 = false;
              } else {
                this.$message.error(`没有查询到车牌号`);
              }
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
      } else if (
        reimbursementDirection ==
        "bill_tms_waybill_outgoing_v3:reimbursement_direction"
      ) {
        // 外发 outgoingNumber

        return this.$API
          .getOutgoingList({
            ...this.queryData4,
          })
          .then((res) => {
            if (res.data.status === "success") {
              let datas = res.data.result.data || [];
              if (datas.length) {
                let cursnum = datas[0].documentNumber;
                if (
                  this.tableData1
                    .map((n) => {
                      return n.documentNumber;
                    })
                    .includes(cursnum)
                ) {
                  this.$message.error(
                    `外发编号 ${cursnum} 添加重复，请输入新的外发编号`
                  );
                  return false;
                }
                datas[0].operationType = "ADD";
                this.tableData1.push(datas[0]);
                this.isShowDialog2 = false;
              } else {
                this.$message.error(`没有查询到外发编号 `);
              }
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
      } else if (
        reimbursementDirection == "bill_tms_dispatch_v3:reimbursement_direction"
      ) {
        // 发车 number
        return this.$API
          .wtl_getDispatchList({
            ...this.queryData5,
          })
          .then((res) => {
            if (res.data.status === "success") {
              let datas = res.data.result.data || [];
              if (datas.length) {
                let cursnum = datas[0].documentNumber;
                if (
                  this.tableData1
                    .map((n) => {
                      return n.documentNumber;
                    })
                    .includes(cursnum)
                ) {
                  this.$message.error(
                    `发车批次号 ${cursnum} 添加重复，请输入新的发车批次号`
                  );
                  return false;
                }
                datas[0].operationType = "ADD";
                this.tableData1.push(datas[0]);
                this.isShowDialog2 = false;
              } else {
                this.$message.error(`没有查询到发车批次号`);
              }
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
      }
    },

    // 获取客户列表
    getCustomerList(number) {
      this.$API
        .wtl_getObjectUserDownList({
          key: "customer",
          name: number,
          number: "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    // 选择客户触发
    changeCustomerNumber(e) {
      if (!e) {
        this.getCustomerList();
      }
    }, // 时间组件 选择时间后触发

    // 运单
    queryBtn_time3(s, e) {
      this.startTime_a3 = s || "";
      this.endTime_a3 = e || "";
    }, // 时间组件 选择类型后触发
    timestatus3(type, s, e) {
      this.timeType3 = type || "0";
      this.startTime_a3 = s || "";
      this.endTime_a3 = e || "";
    },
    //取出明细
    handleCloseDia3() {
      this.isShowDialog3 = false;
      this.queryData3 = {
        waybillNumber: "",
        startBusinessTime: "",
        startCreateTime: "",
        endBusinessTime: "",
        endCreateTime: "",
      };
    },
    //取出明细  弹窗确认保存事件
    diaConfirmBtn3() {
      // 添加费项
      if (!this.selectTableData3.length) {
        this.$message.error(`请选择操作数据`);
        return false;
      }
      this.tableData1 = this.arrayFilter(
        [...this.selectTableData3, ...this.tableData1],
        "documentNumber"
      );
      // waybillNumber
      this.isShowDialog3 = false;
    },

    arrayFilter(arr, key) {
      return arr.filter((item, index, self) => {
        // 利用findIndex方法找到第一个与当前元素id相等的元素索引
        const i = self.findIndex((t) => t[key] === item[key]);
        // 如果当前索引等于当前元素在self中的最初出现位置索引，则表示元素符合要求，不是重复元素，保留
        return i === index;
      });
    },
    //取出明细 点击选中当前行
    rowclick3(row, event, column) {
      this.$refs.mytable3.toggleRowSelection(row);
    },
    //取出明细 表格选择事件
    handleSelectionChange3(e) {
      this.selectTableData3 = e;
    },
    clickQuery3(page) {
      if (page && page == 1) {
        this.pageStart3 = 1;
      }
      let startBusinessTime = "";
      let endBusinessTime = "";
      let startCreateTime = "";
      let endCreateTime = "";

      let startTime = this.startTime_a3 ? this.startTime_a3 + " 00:00:00" : "";
      let endTime = this.endTime_a3 ? this.endTime_a3 + " 23:59:59" : "";

      if (this.timeType3 == "0") {
        startCreateTime = startTime;
        endCreateTime = endTime;
      }
      if (this.timeType3 == "1") {
        startBusinessTime = startTime;
        endBusinessTime = endTime;
      }
      let param = {
        ...this.queryData3,
        pageStart: this.pageStart3,
        pageTotal: this.pageTotal3,
        startBusinessTime: startBusinessTime,
        endBusinessTime: endBusinessTime,
        startCreateTime: startCreateTime,
        endCreateTime: endCreateTime,
        waybillNumberNoLike: "",
      };

      return this.$API.wtl_getWaybillList(param).then((res) => {
        if (res.data.status === "success") {
          this.tableData3 = res.data.result.data || [];
          this.pageCount3 = res.data.result.pageCount;
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    // 外发——————————
    queryBtn_time4(s, e) {
      this.startTime_a4 = s || "";
      this.endTime_a4 = e || "";
    }, // 时间组件 选择类型后触发
    timestatus4(type, s, e) {
      this.timeType4 = type || "0";
      this.startTime_a4 = s || "";
      this.endTime_a4 = e || "";
    },
    //取出明细
    handleCloseDia4() {
      this.isShowDialog4 = false;
      this.queryData4 = {
        number: "",
        endCreateTime: "",
        endOutgoingTime: "",
        startCreateTime: "",
        startOutgoingTime: "",
        waybillNumber: "",
        customerName: "",
        carrierName: "",
        sendEmployeeId: "",
        businessDeptId: "",
      };
    },
    //取出明细  弹窗确认保存事件
    diaConfirmBtn4() {
      // 添加费项
      if (!this.selectTableData4.length) {
        this.$message.error(`请选择操作数据`);
        return false;
      }
      this.tableData1 = this.arrayFilter(
        [...this.selectTableData4, ...this.tableData1],
        "documentNumber"
      );
      // number
      this.isShowDialog4 = false;
    },
    //取出明细 点击选中当前行
    rowclick4(row, event, column) {
      this.$refs.mytable4.toggleRowSelection(row);
    },
    //取出明细 表格选择事件
    handleSelectionChange4(e) {
      this.selectTableData4 = e;
    },
    clickQuery4(page) {
      if (page && page == 1) {
        this.pageStart4 = 1;
      }
      let startOutgoingTime = "";
      let endOutgoingTime = "";
      let startCreateTime = "";
      let endCreateTime = "";
      let startTakeTime = "";
      let endTakeTime = "";

      let startTime = this.startTime_a4 ? this.startTime_a4 + " 00:00:00" : "";
      let endTime = this.endTime_a4 ? this.endTime_a4 + " 23:59:59" : "";

      if (this.timeType4 == "0") {
        startCreateTime = startTime;
        endCreateTime = endTime;
      }
      if (this.timeType4 == "1") {
        startOutgoingTime = startTime;
        endOutgoingTime = endTime;
      }
      if (this.timeType4 == "2") {
        startTakeTime = startTime;
        endTakeTime = endTime;
      }
      let param = {
        ...this.queryData4,
        pageStart: this.pageStart4,
        pageTotal: this.pageTotal4,
        startOutgoingTime: startOutgoingTime,
        endOutgoingTime: endOutgoingTime,
        startCreateTime: startCreateTime,
        endCreateTime: endCreateTime,
        startTakeTime,
        endTakeTime,
        waybillNumberNoLike: "",
        isPosting: 0,
      };

      return this.$API.getOutgoingList(param).then((res) => {
        if (res.data.status === "success") {
          this.tableData4 = res.data.result.data || [];
          this.pageCount4 = res.data.result.pageCount;
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    // 发车——————————
    queryBtn_time5(s, e) {
      this.startTime_a5 = s || "";
      this.endTime_a5 = e || "";
    }, // 时间组件 选择类型后触发
    timestatus5(type, s, e) {
      this.timeType5 = type || "0";
      this.startTime_a5 = s || "";
      this.endTime_a5 = e || "";
    },
    //取出明细
    handleCloseDia5() {
      this.isShowDialog5 = false;
      this.queryData5 = {
        number: "",
        endCreateTime: "",
        endDepartureTime: "",
        startDepartureTime: "",
        startCreateTime: "",
        waybillNumber: "",
        preparerEmployeeId: "",
      };
    },
    //取出明细  弹窗确认保存事件
    diaConfirmBtn5() {
      // 添加费项
      this.tableData1 = this.arrayFilter(
        [...this.selectTableData5, ...this.tableData1],
        "documentNumber"
      );
      // number
      this.isShowDialog5 = false;
    },
    //取出明细 点击选中当前行
    rowclick5(row, event, column) {
      this.$refs.mytable5.toggleRowSelection(row);
    },
    //取出明细 表格选择事件
    handleSelectionChange5(e) {
      this.selectTableData5 = e;
    },
    clickQuery5(page) {
      if (page && page == 1) {
        this.pageStart5 = 1;
      }
      let startDepartureTime = "";
      let endDepartureTime = "";
      let startCreateTime = "";
      let endCreateTime = "";

      let startTime = this.startTime_a5 ? this.startTime_a5 + " 00:00:00" : "";
      let endTime = this.endTime_a5 ? this.endTime_a5 + " 23:59:59" : "";

      if (this.timeType5 == "0") {
        startCreateTime = startTime;
        endCreateTime = endTime;
      }
      if (this.timeType5 == "1") {
        startDepartureTime = startTime;
        endDepartureTime = endTime;
      }
      let param = {
        ...this.queryData5,
        pageStart: this.pageStart5,
        pageTotal: this.pageTotal5,
        startDepartureTime: startDepartureTime,
        endDepartureTime: endDepartureTime,
        startCreateTime: startCreateTime,
        endCreateTime: endCreateTime,
        waybillNumberNoLike: "",
        isPosting: 0,
      };

      return this.$API.wtl_getDispatchList(param).then((res) => {
        if (res.data.status === "success") {
          this.tableData5 = res.data.result.data || [];
          this.pageCount5 = res.data.result.pageCount;
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    // 车辆 ——————————
    //取出明细
    handleCloseDia6() {
      this.isShowDialog6 = false;
      this.queryData6 = {
        carNumber: "",
      };
    },
    //取出明细  弹窗确认保存事件
    diaConfirmBtn6() {
      // 添加费项
      this.tableData1 = this.arrayFilter(
        [...this.selectTableData6, ...this.tableData1],
        "documentNumber"
      );
      // carNumber
      this.isShowDialog6 = false;
    },
    //取出明细 点击选中当前行
    rowclick6(row, event, column) {
      this.$refs.mytable6.toggleRowSelection(row);
    },
    //取出明细 表格选择事件
    handleSelectionChange6(e) {
      this.selectTableData6 = e;
    },
    clickQuery6(page) {
      if (page && page == 1) {
        this.pageStart6 = 1;
      }
      let param = {
        pageStart: this.pageStart6,
        pageTotal: this.pageTotal6,
        ...this.queryData6,
      };

      return this.$API.CarArchiveList(param).then((res) => {
        if (res.data.status === "success") {
          this.tableData6 = res.data.result.data || [];
          this.pageCount6 = res.data.result.pageCount;
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    // 运单应付 ——————————
    //取出明细
    handleCloseDia7() {
      this.isShowDialog7 = false;
    },
    //取出明细  弹窗确认保存事件
    diaConfirmBtn7() {
      // 添加费项
      this.tableData1 = this.arrayFilter(
        [...this.selectTableData, ...this.tableData1],
        "documentNumber"
      );
      // number
      this.isShowDialog7 = false;
    },

    // 这里没有引入公用的动态条件方法
    // async getData() {
    //   let conditionReqs = [];
    //   let F_config = this.$refs.queryForm.F_config;
    //   F_config.forEach(async (element) => {
    //     let {
    //       textBoxType,
    //       conditonKey,
    //       dropdownSubmitField,
    //       conditonVal,
    //       defaultSelectVal,
    //       timeType,
    //       timeChilds,
    //       startTime_a,
    //       endTime_a,
    //       dropdownShowField,
    //       dropdownApiNumber,
    //     } = element;
    //     switch (textBoxType) {
    //       case "input":
    //         conditionReqs.push({
    //           conditonKey,
    //           conditonVal,
    //         });
    //         break;

    //       case "input_more":
    //         conditionReqs.push({
    //           conditonKey,
    //           conditonVal: (conditonVal && conditonVal.split("/")) || [],
    //         });
    //         break;
    //       case "select":
    //         console.log(conditonVal);
    //         conditionReqs.push({
    //           conditonKey: conditonKey,
    //           // conditonKey: dropdownSubmitField || conditonKey,
    //           conditonVal,
    //         });
    //         break;
    //       case "select_object":
    //         conditionReqs.push({
    //           conditonKey: conditonKey,
    //           conditonVal,
    //         });
    //         break;
    //       case "datetime":
    //         let curs = timeChilds[timeType];
    //         curs &&
    //           curs.children.forEach((element, index) => {
    //             let endTime_agg = endTime_a ? `${endTime_a} 23:59:59` : "";
    //             let startTime_agg = startTime_a
    //               ? `${startTime_a} 00:00:00`
    //               : "";
    //             conditionReqs.push({
    //               conditonKey: element.conditonKey,
    //               conditonVal: index == 1 ? endTime_agg : startTime_agg,
    //             });
    //           });
    //         break;
    //       default:
    //         break;
    //     }
    //   });
    //   let params = {
    //     conditionReqs,
    //     pageStart: this.pageStart,
    //     pageTotal: this.pageTotal,
    //     number: this.reportFiledsNumber,
    //   };
    //   await this.$API.runPageReport(params).then((res) => {
    //     if (res.data.status === "success") {
    //       let datas = res.data.result.datas || {};
    //       this.className = datas.className || "";
    //       this.tableData = datas.data || [];
    //       this.pageCount = datas.pageCount || 0;
    //     } else {
    //       this.$message.error(`${res.data.message}---综合查询列表`);
    //     }
    //   });
    // },
    async initTable() {
      // //获取 所有页面 number
      // await this.$API
      //   .getQueryList({
      //     number: "",
      //     reportName: "",
      //   })
      //   .then((res) => {});
      // //获取当前页面已设置表头
      // await this.$API
      //   .getGroupFindFieldSort({
      //     groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
      //   })
      //   .then((res) => {
      //     let arr = res.data.result || [];
      //     // if (arr.length > 0) {
      //     //   if (arr[0].sortObject) {
      //     //     this.tabelHeadeTitle = JSON.parse(arr[0].sortObject);
      //     //     this.sortName = arr[0].sortName;
      //     //   }
      //     // }
      //     if (arr.length > 0) {
      //       if (arr[0].sortObject) {
      //         this.myTableHeard = JSON.parse(arr[0].sortObject);
      //         this.sortName = arr[0].sortName;
      //       }
      //     } else {
      //       this.myTableHeard = [];
      //     }
      //     let totalArr = [];
      //     //提取需要合计的字段
      //     for (var i = 0; i < this.myTableHeard.length; i++) {
      //       if (this.myTableHeard[i].isTotal) {
      //         totalArr.push(this.myTableHeard[i].field);
      //       }
      //     }
      //     this.totalArr = totalArr;
      //   });
      //表格 表头默认
      await this.$API
        .getReportFileds({
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          let lists = [];
          datas.forEach((element) => {
            lists.push({
              name: element.fieldNameShow,
              field: element.fieldAlias,
              width: element.wide,
              isTotal: element.isSum,
              sort: element.sort,
              isShow: element.isShow == 0 ? false : true,
              isSort: true,
            });
          });
          this.originalTabelHeadeTitle = lists;
          if (!this.tabelHeadeTitle.length) {
            this.tabelHeadeTitle = this.originalTabelHeadeTitle;
          }
        });
      if (this.myTableHeard.length == 0) {
        this.myTableHeard = this.tabelHeadeTitle;
      }

      this.myTableHeard1 = this.myTableHeard;

      let arrsConddition = [];
      // 获取查询条件 list
      await this.$API
        .getReportConditions({
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          if (datas && datas.length > 0) {
            datas.map((n) => (n.conditonVal = n.conditonVal || ""));
            let arrs = datas.filter((n) => {
              return n.textBoxType === "datetime" && n.isShow;
            });
            console.log(arrs);
            let timeobjs = {};
            arrs.forEach((item) => {
              let { sort, conditonKeyShow } = item;
              let name = conditonKeyShow.includes("起始")
                ? conditonKeyShow.split("起始").join("")
                : conditonKeyShow.split("结束").join("");
              if (!timeobjs[sort]) {
                timeobjs[sort] = {
                  sort,
                  name,
                  children: [],
                };
              }
              timeobjs[sort].children.push(item);
            });
            let gdates = [];
            let dates = Object.values(timeobjs);
            if (dates.length) {
              gdates = [
                {
                  textBoxType: "datetime",
                  startTime_a: this.$TOOLS.getFlexDate(this.$COMMON.timeNum),
                  endTime_a: this.$TOOLS.getCurrentDate(),
                  timeType: "0",
                  timeTypes: dates.map((n, i) => {
                    return { value: String(i), label: n.name };
                  }),
                  timeChilds: dates.map((n, i) => {
                    return { sort: n.sort, name: n.name, children: n.children };
                  }),
                  isShow: 1,
                },
              ];
            }
            console.log(gdates);
            arrsConddition = [
              ...gdates,
              ...datas.filter((n) => {
                return n.textBoxType !== "datetime";
              }),
            ];
          }
        });
      // 获取 每个查询条件 的下拉数据
      const promisemap = arrsConddition.map(async (element, index) => {
        let {
          textBoxType,
          dropdownShowField,
          dropdownApiNumber,
          defaultSelectVal,
        } = element;
        if (textBoxType == "select") {
          let selectOptions = [];
          if (defaultSelectVal) {
            await this.$API
              .runPageReport({
                conditionReqs: [
                  {
                    conditonKey: dropdownShowField,
                    conditonVal: "",
                  },
                ],
                number: dropdownApiNumber,
                pageStart: 1,
                pageTotal: 20,
              })
              .then((res) => {
                let datas = res.data.result.datas.data || [];
                selectOptions = datas;
              });
            element.conditonVal = defaultSelectVal || "";
          }
          element.selectOptions = selectOptions;
        }
      });
      await Promise.all(promisemap);
      this.queryCondditionDatas = arrsConddition;
    },

    handleCloseDia8() {
      this.isShowDialog8 = false;
      this.fileNameLists8 = [];
      this.queryData8 = {
        financeId: "",
        financeNumber: "",
        settlementAmount: "",
        accountId: "",
        writeOffTime: "",
        writeoffComment: "",
        writeOffPics: [],
      };
    },

    diaConfirmBtn8() {
      // number

      this.queryData8.writeOffPics = this.fileNameLists8.map((item) => {
        return item.name;
      });
      let param = {
        accountId: this.queryData8.accountId,
        financeId: this.queryData8.financeId,
        writeOffPics: this.queryData8.writeOffPics,
        writeOffTime: this.queryData8.writeOffTime,
        writeoffComment: this.queryData8.writeoffComment,
      };
      this.$API.writeOffExpense(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.isShowDialog8 = false;

        this.$TOOLS.closePage();
        this.$router.push({
          path: "/FinancialManagement/ExpenseReimbursement",
          query: {
            isreload: "isreload",
          },
        });
      });
    },

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable7.toggleRowSelection(row);
    },
    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.clickQuery7();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.clickQuery7();
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    clickQuery7(page) {
      if (page && page == 1) {
        this.pageStart = 1;
      }
      this.getData();
    },
  },
};
</script>
<style scoped lang="less">
.twoInput {
  display: flex;
}
.topBtns {
  width: calc(100% - 210px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  height: 50px;
}
.contentBox {
  padding-bottom: 50px;
}
// 查询条件边框线
@borderColor: #cccccc;
.infoDiv {
  margin-bottom: 20px;
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
.textArea {
  height: auto !important;
}
.goodg {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}
.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .uploadLaber {
    margin-right: 10px;
  }
  .uploadItem {
    flex: 1;
  }
}
.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}
.hasMoreParam {
  .glo_btnItems {
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
  }
}
.jsInput {
  display: flex;
  align-items: center;
  width: 100%;
  .jsBtns {
    height: 34px;
    line-height: 34px;
    margin: 0;
    padding: 0 10px;
    border: none;
  }
}

/deep/ .glo_formBox .el-form-item {
  min-width: 300px !important;
}
</style>
